import { Injectable } from '@angular/core';

export enum ToolCapaciteVersionsEnum {
  DSD
}

@Injectable({
  providedIn: 'any'
})
export class ToolCapaciteVersionService {
  constructor() {}

  get version(): ToolCapaciteVersionsEnum {
    return ToolCapaciteVersionsEnum.DSD;
  }
}
